import { BaseSearchingCriteria } from './customer/company';

export type OnepageProductStatus = 'ENABLED' | 'DISABLED';

export class OnepageProduct {
    productId: string;
    productCode: string;
    productName: string;
    description: string;
    productNameTc: string;
    descriptionTc: string;
    productPrice: number;
    status: OnepageProductStatus;

    campaignId: string;

    _selected: boolean;

    constructor() {
        this.status = 'ENABLED';
        this._selected = false;
    }
 
}

export class OnepageProductFormSearchingCriteria extends BaseSearchingCriteria {
    status: OnepageProductStatus;
    code: string;
    name: string;
}

export class OnepageProductOption{
    productId: string;
    productName: string;
}